/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {catchError, map, Observable, of} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from './adn-api-client.service';

@Injectable({providedIn: 'root'})
export class TwoFactorAuthRecoveryApiService {
  private readonly uri = this.apiConfig.getVersionedUri('2fa');

  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getRecoveryUsers(userId: string, networkId: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.recoveryUri('verifiers', userId),
      params: {context: networkId}
    }).pipe(catchError(() => of(null)));
  }

  getVerifyingUsers(userId: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.recoveryUri('verifying', userId)
    }).pipe(catchError(() => of(null)));
  }

  getRecoveryUser(userId: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.recoveryUri('user', userId)
    }).pipe(catchError((response) => of(response)));
  }

  submitVerifyUser(userId: string, verifyUserId: string, networkId: string): Observable<any> {
    return this.client.request({
      method: 'POST',
      url: this.uri + '/recovery/initiate',
      params: {context: networkId},
      body: {recoveryUser: userId, verifyUser: verifyUserId}
    }).pipe(
      map(() => true),
      catchError((response) => of(response.data))
    );
  }

  submitVerifiedUser(userId: string, code: string): Observable<any> {
    return this.client.request({
      method: 'POST',
      url: this.uri + '/recovery/verify',
      body: {recoveryUser: userId, code}
    }).pipe(
      map(() => true),
      catchError((response) => of(response.data))
    );
  }

  private recoveryUri(type: string, userId: string): string {
    return this.uri + '/recovery/' + type + '/' + encodeURIComponent(userId);
  }
}
